module.exports = __webpack_public_path__ + "img/icon-qrcode-border-tr.640a222c.svg";